// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".syte_item_review_stars_CqOkX{align-items:center;display:flex;margin:0;max-height:16px;padding:0}.syte_item_review_stars_CqOkX img{position:relative;top:-1px;vertical-align:middle}.syte_item_review_stars_CqOkX .img-not-loaded{height:16px!important;width:89px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"syte_item_review_stars": "syte_item_review_stars_CqOkX"
};
module.exports = ___CSS_LOADER_EXPORT___;
